/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Frontend stub for the live-simulation backend. The backend endpoint
 * /api/simulation/run does NOT exist yet — this file exists so the
 * simulation showcase UI can wire its "Run live simulation" button
 * even before the backend is built. When the Modal-backed endpoint
 * lands (post-Phase-7 if live simulation gets activated), no UI
 * change is required.
 */

import { FLAGS } from './featureFlags';

export async function requestLiveSimulation(slug, params = {}) {
  if (!FLAGS.LIVE_SIMULATION) {
    return { error: 'Live simulation not enabled' };
  }
  try {
    const res = await fetch('/api/simulation/run', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug, params }),
    });
    if (!res.ok) {
      return { error: `HTTP ${res.status}` };
    }
    return await res.json();
  } catch (err) {
    return { error: err.message };
  }
}

export default requestLiveSimulation;
